module.exports = ".selected-option{\r\n    background: #673ab7;\r\n    color: #fff;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/main-menu/main-menu.component.css
// module id = ./src/app/main-menu/main-menu.component.css
// module chunks = main